<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-10">
        <h3 class="text-center">Relatório de Produção Mensal</h3>
      </div>
    </div>
    <br />
    <div class="row" id="conteudo">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row" id="dados">
              <div class="col-md-4">
                <label>Tipo</label>
                <br />
                {{ type_profile ? type_profile.name : '-' }}
              </div>
              <div class="col-md-4">
                <label>Status</label>
                <br />
                {{ status ? status.name : '-' }}
              </div>
              <div class="col-md-4">
                <label>Administradora</label>
                <br />
                {{ administrator ? administrator.name : '-' }}
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-4">
                <label>Período</label>
                <br />
                {{ dateType.name }}
              </div>
              <div class="col-md-4">
                <label>Intervalo</label>
                <br />
                {{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="panel-defaul">
          <table-report id="tabela-excel" v-bind:items="proposals" v-bind:date_type="dateType" ref="report"></table-report>
        </div>
      </div>
    </div>
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <button type="button" @click="pdf()" class="btn btn-fill btn-info">PDF</button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import TableReport from "@/components/elements/TableReportCommissionOfMonths";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
export default {
  components: {
    "table-report": TableReport
  },
  computed: {
    administrators: {
      get() {
        return this.$store.state.administrators.itens;
      }
    },
    dateType: {
      get() {
        var self = this;
        var dateType = self.date_types.find(
          date_type => date_type.id == self.form.date_type
        );
        if (dateType !== undefined) {
          return dateType;
        } else {
          return {
            id: 0,
            name: "-"
          };
        }
      }
    },
    date_types: {
      get() {
        return [
          { id: "month", name: "Mensal" },
          { id: "range", name: "Faixa" }
        ];
      }
    },
    proposal_status: {
      get() {
        return [
          {
            id: 1,
            name: "Novas"
          },
          {
            id: 3,
            name: "Contempladas"
          },
          {
            id: 4,
            name: "Faturadas"
          },
          {
            id: 5,
            name: "Canceladas"
          },
          {
            id: "",
            name: "Todas"
          }
        ];
      }
    }
  },
  data() {
    return {
      administrator: {
        id: 0,
        name: "-"
      },
      end_at: null,
      form: {},
      init_at: null,
      proposals: [],
      status: null,
      type_profile: null,
      type_profiles: [
        { id: "salesmans", name: "Vendedores" },
        { id: "teams", name: "Equipes" }
      ]
    };
  },
  methods: {
    close() {
      window.opener.focus();
      window.close();
    },
    async getData() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch(
        "reports/commissionOfMonths",
        self.form
      );

      response.then(function(_proposals) {
        self.$root.$emit("onLoading");

        self.proposals = _proposals;
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function(_administrators) {
        var administrator = _administrators.find(
          administrator => administrator.id === self.form.administrator_id
        );
        // console.log(administrator);
        if (administrator !== undefined) {
          self.administrator = administrator;
        } else self.administrator = { name: "Todas" };

        self.$root.$emit("onLoading");
        self.getData();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getData();
      });
    },
    print() {
      window.print();
    },
    async pdf() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "reports/commissionOfMonthsDownloadInPdf",
        {
          'filters': self.form,
          'data': self.$refs.report.reportData(),
        }
      )

      response.then(function(_downloadPdf) {
          let filename = 'commission-of-months.pdf'
          let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click();

          self.$root.$emit("onLoading")
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    }
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);

    if (self.form.date_type == 'month') {
      self.form.date_at[0] = Vue.moment(self.form.date_at[0]).startOf('month').format();
      self.form.date_at[1] = Vue.moment(self.form.date_at[1]).endOf('month').format();
    }

    self.getDataAdministrators();

    self.init_at = self.form.date_at[0];

    self.end_at = self.form.date_at[1];

    self.type_profile = self.type_profiles.find(
      type_profile => type_profile.id == self.form.type
    );

    self.status = self.proposal_status.find(
      status => status.id == self.form.proposal_status_id
    );
  }
};
</script>

<style type="scss">
.link {
  cursor: pointer;
}
tr {
  word-wrap: break-word;
}
body {
  overflow:auto;
}

@media print {
  .dont-print {
    display: none;
  }
  .table .thead-dark th {
    color: #aaaaaa;
  }
  .table{
    width: 50%;
  }
  @page{
    size: landscape;
  }
}
</style>
